export default "__VITE_ASSET__C8wsVooH__"